<template>
	<div v-if="publication && publication.url" id="pub">
		<v-btn
			color="accent"
			fab
			fixed
			right
			id="toolbar title"
			style="z-index: 1; margin-top: 10px;"
		>
			{{ currentPage }}/{{ pageCount }}
		</v-btn>
		<v-btn
			v-if="page != 1"
			color="accent"
			fab
			fixed
			right
			id="toolbar title"
			style="z-index: 1; margin-top: 70px;"
			@click="prevPage"
		>
			<v-icon center>mdi-arrow-left</v-icon>
		</v-btn>
		<v-btn
			v-if="page != pageCount"
			color="accent"
			fab
			fixed
			right
			id="toolbar title"
			style="z-index: 1; margin-top: 130px"
			@click="nextPage"
		>
			<v-icon center>mdi-arrow-right</v-icon>
		</v-btn>
		<v-btn
			:color="sliderValue > 99 ? 'success' : 'primary'"
			fab
			fixed
			right
			id="toolbar title"
			style="z-index: 1; margin-top: 190px"
		>
			{{ sliderValue.toFixed(0) }}
		</v-btn>
		<v-progress-linear
			:value="sliderValue"
			top
			fixed
			style="z-index: 1; margin-top:30px; position:fixed;"
		>
		</v-progress-linear>
		<div id="render-pdf">
			<pdf
				:page="page"
				:src="publication.url"
				@num-pages="pageCount = $event"
				@page-loaded="
					currentPage = $event;
					evalSize();
				"
				style="width:100%;"
			></pdf>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import pdf from 'vue-pdf';

export default {
	components: {
		pdf,
	},
	props: {
		publicationId: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			change: false,
			page: 1,
			currentPage: 1,
			pageCount: 0,
			delay: false,
			read: false,
			dateSeen: null,
			maxProgress: 0,
			sliderValue: 0,
			countUp: 0,
			beforeCountUp: 0,
		};
	},
	computed: {
		readed() {
			return this.page == this.pageCount;
		},
		publication() {
			return this.person?.publications.find(item => item._id === this.publicationId);
		},
		...mapGetters({
			person: 'Person/person',
		}),
	},
	created() {
		document.addEventListener('visibilitychange', this.visibilityListener);
		this.visibilityListener();
		this.scroll();
	},
	watch: {
		publication() {
			this.countUp = this.publication.visibilityTime;
			this.beforeCountUp = this.publication.visibilityTime;
		},
	},
	methods: {
		async onSubmit() {
			await this.updatePublication({
				personId: this.person._id,
				publicationId: this.publicationId,
				visibilityTime: this.countUp,
				seen: this.publication.seen || this.read,
				dateSeen: this.publication.dateSeen || this.dateSeen,
			});
		},
		visibilityListener() {
			if (document.visibilityState === 'visible') {
				setTimeout(() => {
					this.countUp += 1;
					this.visibilityListener();
					// Si han pasado 30 seg actualiza el tiempo que ha visto
					if (this.publication && this.beforeCountUp + 30 === this.countUp) {
						this.beforeCountUp = this.countUp;
						this.onSubmit();
					}
				}, 1000);
			}
		},
		prevPage() {
			this.page--;
			document.documentElement.scrollTop = document.documentElement.offsetHeight;
			this.sliderValue = 100;
			this.evalSize();
		},
		nextPage() {
			this.page++;
			document.documentElement.scrollTop = 1;
			this.sliderValue = 0;
			this.evalSize();
		},
		scroll() {
			window.onscroll = () => {
				let max =
					Math.max(
						window.pageYOffset,
						document.documentElement.scrollTop,
						document.body.scrollTop
					) + window.innerHeight;
				this.maxProgress = document.documentElement.offsetHeight;
				let temporalValue = (max * 100) / this.maxProgress;
				if (temporalValue > this.sliderValue) {
					this.sliderValue = (max * 100) / this.maxProgress;
				}
				let bottomOfWindow = Math.ceil(max) === document.documentElement.offsetHeight;

				if (!this.delay) {
					if (bottomOfWindow && this.readed && !this.publication.seen) {
						this.read = true;
						this.dateSeen = Date.now();
						this.setDelay();
						this.onSubmit();
					}
				} else {
					document.documentElement.scrollTop = 50;
				}
			};
		},
		evalSize() {
			let box = document.querySelector('#render-pdf');
			let max =
				Math.max(
					window.pageYOffset,
					document.documentElement.scrollTop,
					document.body.scrollTop
				) + window.innerHeight;
			if (box.offsetHeight <= max && this.readed && !this.publication.seen) {
				this.sliderValue = 100;
				this.read = true;
			} else if (box.offsetHeight <= max && this.readed && this.publication.seen) {
				this.sliderValue = 100;
			}
		},
		setDelay() {
			this.delay = true;
			setTimeout(() => {
				this.delay = false;
			}, 300);
		},
		...mapActions({
			updatePublication: 'Person/updatePublication',
		}),
	},
};
</script>
